module.exports = "img/taller-ab-2.b58544.jpg";